import AcctMgmt from './acct-mgmt.svg';
import CX from './cx.svg';
import DataAnalysis from './data-analysis.svg';
import Engineering from './engineering.svg';
import Marketing from './marketing.svg';
import ProductMgmt from './product-mgmt.svg';
import Support from './support.svg';
import UX from './ux.svg';

export default {
  'personas/acct-mgmt': AcctMgmt,
  'personas/cx': CX,
  'personas/data-analysis': DataAnalysis,
  'personas/engineering': Engineering,
  'personas/marketing': Marketing,
  'personas/product-mgmt': ProductMgmt,
  'personas/support': Support,
  'personas/ux': UX,
};
